module.exports = __webpack_public_path__ + "static/media/patron-3.262ba8e6.svg";